import { render, staticRenderFns } from "./PDPCommentButtons.vue?vue&type=template&id=52edc8cc&scoped=true&"
import script from "./PDPCommentButtons.vue?vue&type=script&lang=js&"
export * from "./PDPCommentButtons.vue?vue&type=script&lang=js&"
import style0 from "./PDPCommentButtons.vue?vue&type=style&index=0&id=52edc8cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52edc8cc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/app/appsumo/nuxt/components/wishlists/Button.vue').default})
